module.exports = __webpack_public_path__ + "static/img/elephant_empty1.877a375.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/elephant_empty1.png
// module id = CPNy
// module chunks = 9